const { file: DefaultDCIgnore } = require('./full.dcignore.js');
const { file: CustomDCIgnore } = require('./empty.dcignore.js');

module.exports = {
  DefaultDCIgnore,
  CustomDCIgnore,
};
